<template>
  <div class="designerIndex">
    <div class="banner">
      <img
        src="../../assets/case/index/kv.png"
        alt=""
        srcset=""
        ref="kv"
      />
      <div class="search-content">
        <el-input v-model="formdata.keyword" placeholder="案例名称搜索"></el-input>
        <div class="search-btn" @click="getsearch">
          <img class="search-icon" src="../../assets/case/index/search-icon.png" alt="" srcset="">
        </div>
      </div>
    </div>
    <div class="container" ref="container">
      <div class="designerCase">
        <div class="case-content">
          <div
            class="caseItem"
            v-for="(caseItem, index) in caseList"
            :key="index"
            @click="showDailog(caseItem)"
          >
            <img class="title-pic" :src="caseItem.adv_pic" />
            <div class="cover">
              <div class="info-font">查看详情</div>
            </div>
            <div class="title-name">{{ caseItem.adv_title }}</div>
          </div>
          <div v-if="showBtn && caseList.length > 0" :class="['toomore', {'disabled': isloading} ]" @click="next">
            <span v-if="isloading"><i class="el-icon-loading"></i>加载中</span>
            <span v-else>更多</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showPopup"
      custom-class="dialog"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
    >
      <div class="dialog-box">
        <img class="closebtn" src="../../assets/serve/designer/close.png" @click="closeDialog">
        <img class="leftbtn" src="../../assets/serve/designer/left.png" @click="left">
        <img class="rightbtn" src="../../assets/serve/designer/right.png" @click="right">
        <div class="title" v-if="dialogData.adv_title">{{ dialogData.adv_title }}</div>
        <div class="desc" v-if="dialogData.adv_desc">{{ dialogData.adv_desc }}</div>
        <div class="dialog-html" v-html="dialogInfo"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/util/request'
import { doAdvertiseGeneralList, getAdvertiseGeneralAppletAround } from "@/api/case.js";
export default {
  name: "designerIndex",
  components: {
  },
  watch: {},
  data() {
    return {
      formdata: {
        keyword: '',
        pageNum: 1,
        pageSize: 6
      },
      // kvList: [
      //   require("@/assets/serve/index/serveKV.png"),
      //   require("@/assets/serve/index/serveKV.png"),
      // ],
      caseList: [],
      sceneList: [],
      dialogData: {},
      showPopup: false,
      showBtn: true,
      isloading: false,
      dialogInfo: ''
    };
  },
  async created() {
    await this.getcaseList()
  },
  mounted() {
    // this.$emit('needLogin', true)
  },
  methods: {
    getsearch() {
      this.caseList = []
      this.formdata.pageNum = 1
      this.getcaseList()
    },
    // 案例列表
    getcaseList() {
      doAdvertiseGeneralList({
        adv_sign: 1,
        adv_type: '-1',
        adv_state: '-1',
        keyword: this.formdata.keyword,
        pageNum: this.formdata.pageNum,
        pageSize: this.formdata.pageSize,
      }).then((res) => {
        if (res.result == 1) {
          if (res.dataList && res.dataList.length > 0) {
          this.caseList = [...this.caseList, ...res.dataList]
          if (res.dataList.length >= this.formdata.pageSize) {
            this.showBtn = true
          } else {
            this.showBtn = false
          }
        } else {
          this.showBtn = false
        }
        this.isloading = false
        } else {
          this.$message(res.msg);
        }
      });
    },

    next() {
      if (this.isloading) return
      this.formdata.pageNum++
      this.getcaseList()
    },

    showDailog(data) {
      this.showPopup = true;
      this.dialogData = data;
      if (data.applet_url) {
        axios.get('/' + data.applet_url).then(res => {
          this.dialogInfo = res
        })
      }
    },
    closeDialog() {
      this.dialogData = {}
      this.dialogInfo = ''
      this.showPopup = false
    },
    left() {
      getAdvertiseGeneralAppletAround({id: this.dialogData.id}).then (res => {
        console.log('last', res)
        if (res.next) {
          this.dialogData = res.next;
          axios.get('/' + res.next.applet_url).then(res => {
            this.dialogInfo = res
          })
        } else {
          this.$message('没有上一条');
        }
      })
    },
    right() {
      getAdvertiseGeneralAppletAround({id: this.dialogData.id}).then (res => {
        console.log('last', res)
        if (res.last) {
          this.dialogData = res.last;
          axios.get('/' + res.last.applet_url).then(res => {
            this.dialogInfo = res
          })
        } else {
          this.$message('没有下一条');
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.designerIndex {
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  .banner {
    position: relative;
    img {
      width: 100%;
    }
  }
  .search-content {
    width: 768px;
    height: 58px;
    position: absolute;
    background: #FFFFFF;
    border-radius: 16px;
    bottom: 78.5px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    align-content: center;
    text-align: center;
    overflow: hidden;
    /deep/ .el-input__inner {
      border: 0;
      outline: none;
      height: 100%;
      font-size: 24px;
    }
    .search-btn {
      width: 75.5px;
      height: 58px;
      background: #549441;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .search-icon {
        width: 41.5px;
        height: 41.5px;
        vertical-align: top;
      }
    }
  }
  .container {
    width: 100%;
    padding: 90px 96px 50px 96px;
    .designerCase {
      display: flex;
      flex-direction: column;
      .case-content {
        max-width: 1710px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        .caseItem {
          width: 556px;
          margin-bottom: 40px;
          margin-right: 21px;
          cursor: pointer;
          -webkit-user-select: none;
          position: relative;
          .cover {
            width: 556px;
            height: 417px;
            border-radius: 10px;
            background: rgba(0,0,0,.5);
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: all 0.3s linear;
            &:hover {
              opacity: 1;
              
            }
            .info-font {
              width: 153px;
              height: 45px;
              line-height: 42px;
              background: #539441;
              font-family: FZLanTingHeiS-R-GB;
              font-size: 28px;
              font-weight: 400;
              color: #FFFFFF;
              border-radius: 18px 0 18px 0;
            }
          }
          .title-pic {
            width: 556px;
            height: 417px;
            object-fit: cover;
            border-radius: 10px;
            vertical-align: top;
          }
          .title-name {
            font-size: 30px;
            font-family: FZLanTingHeiS-R-GB;
            font-weight: 400;
            color: #000000;
            line-height: 37px;
            margin-top: 21px;
            text-align: left;
          }
          &:nth-of-type(3n) {
            margin-right: 0;
          }
        }
      }
      .toomore {
        width: 466px;
        height: 66px;
        margin: 40px auto;
        background: #e7e7e7;
        font-size: 30px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #999999;
        line-height: 66px;
        text-align: center;
        cursor: pointer;
        -webkit-user-select: none;
        &.disabled {
          background: #f2f2f2;
          color: #ccc;
          cursor: not-allowed;
        }
        /deep/ .el-icon-loading {
          font-size: 30px!important;
          margin-right: 10px;
        }
      }
    }
  }
  /deep/ .el-dialog {
    width: 1180px;
    position: absolute;
    top: 34px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 75px 50px;
    border-radius: 30px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      .dialog-box {
        position: relative;
        .title {
          font-size: 48px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #000000;
          line-height: 60px;
          margin-bottom: 45px;
          text-align: left;
        }
        .desc {
          font-size: 30px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #595858;
          line-height: 44px;
        }
        .dialog-html {
          width: 100%;
          text-align: left;
          img, video {
            width: 100%;
          }
          figure {
            margin: 0 auto;
          }
          .text-tiny{font-size:.7em}
          .text-small{font-size:.85em}
          .text-big{font-size:1.4em}
          .text-huge{font-size:1.8em}
        }
        .closebtn {
          width: 70px;
          height: 70px;
          position: absolute;
          top: -75px;
          right: -220px;
          cursor: pointer;
        }
        .leftbtn {
          width: 58px;
          height: 58px;
          position: absolute;
          top: 430.5px;
          left: -250.5px;
          cursor: pointer;
        }
        .rightbtn {
          width: 58px;
          height: 58px;
          position: absolute;
          top: 430.5px;
          right: -250.5px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>